import * as i0 from '@angular/core';
import { EventEmitter, ViewChildren, Output, Input, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class E11AccordionComponent {
    constructor() {
        /**
         *
         *
         * @type {*}
         * @memberof UiAccordionComponent
         */
        this.data = [];
        /**
         *
         *
         * @type {Style}
         * @memberof UiAccordionComponent
         */
        this.style = 'standard';
        /**
         *
         *
         * @type {Opened}
         * @memberof UiAccordionComponent
         */
        this.opened = '';
        /**
         *
         *
         * @type {number}
         * @memberof UiAccordionComponent
         */
        this.activeIndex = 0;
        /**
         *
         *
         * @type {boolean}
         * @memberof UiAccordionComponent
         */
        this.multiple = false;
        /**
         *
         *
         * @type {(number|null)}
         * @memberof UiAccordionComponent
         */
        this.disabledIndex = null;
        /**
         *
         *
         * @private
         * @memberof UiAccordionComponent
         */
        this.selectedIndexChange = new EventEmitter();
        this.json = [];
        this.json = JSON.stringify(this.data);
    }
    ngOnInit() {
        this.data = [
            {
                sectionName: 'Section One A',
                content: "Lorem 1 Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            },
            {
                sectionName: 'Section Two B',
                content: '<p>Property Two</p><p>Property Two</p>',
            },
            {
                sectionName: 'Section Three C',
                content: '<i class="fas fa-3x fa-code"></i> content Property Six content Property Six content Property Six content Property Six content Property Six content Property Six content Property Six content Property Six content Property Six content Property Six',
            },
            {
                sectionName: 'Section One D',
                content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            },
            {
                sectionName: 'Section One E',
                content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            },
        ];
        setTimeout(() => {
            if (this.opened === 'all') {
                this.data.forEach((element, index) => {
                    this.data[index].isActive = true;
                });
                this.allPanels?.forEach((element) => {
                    element.nativeElement.style.maxHeight = element.nativeElement.scrollHeight + 'px';
                });
            }
            const selectIndex = (sIndex) => {
                if (Array.isArray(sIndex)) {
                    sIndex.forEach((i) => {
                        return selectIndex(i);
                    });
                }
                if (sIndex < this.data.length && sIndex >= 0) {
                    this.data[sIndex].isActive = true;
                    this.allPanels?.forEach((element, i) => {
                        if (i === sIndex) {
                            element.nativeElement.style.maxHeight = element.nativeElement.scrollHeight + 'px';
                        }
                    });
                }
            };
            selectIndex(this.activeIndex);
        }, 250);
    }
    toggleAccordion(event, index) {
        if ((Array.isArray(this.disabledIndex) && this.disabledIndex.includes(+index)) || this.disabledIndex === index) {
            return;
        }
        if (!this.multiple) {
            this.allPanels?.forEach((element) => {
                element.nativeElement.style.maxHeight = null;
            });
            this.data.forEach((el) => {
                el.isActive = false;
            });
        }
        let element = event.target;
        element.classList.toggle('active');
        if (this.data[index].isActive) {
            this.data[index].isActive = false;
        }
        else {
            this.data[index].isActive = true;
            this.selectedIndexChange.emit(index);
        }
        var panel = element.nextElementSibling;
        panel.classList.toggle('active');
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        }
        else {
            panel.style.maxHeight = panel.scrollHeight + 'px';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11AccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11AccordionComponent, isStandalone: true, selector: "e11-accordion", inputs: { data: "data", style: "style", opened: "opened", activeIndex: "activeIndex", multiple: "multiple", disabledIndex: "disabledIndex" }, outputs: { selectedIndexChange: "selectedIndexChange" }, viewQueries: [{ propertyName: "allPanels", predicate: ["contentPanel"], descendants: true }], ngImport: i0, template: "<div class=\"container-accordion e11-w-full\">\n  <div class=\"accordion-item\" *ngFor=\"let item of data; let i = index\">\n    <div\n      class=\"header e11-block e11-clear-right e11-bg-gray-100 hover:e11-bg-gray-200 e11-p-2 e11-cursor-pointer\"\n      (click)=\"toggleAccordion($event, i)\"\n    >\n      {{ item.sectionName }}\n      <span class=\"material-icons-outlined e11-float-right\" *ngIf=\"!item.isActive\"> expand_more </span>\n      <span class=\"material-icons-outlined e11-float-right\" *ngIf=\"item.isActive\"> expand_less </span>\n    </div>\n    <!-- Panel -->\n    <div #contentPanel class=\"panel\" hide=\"!item.isActive\">\n      <div class=\"e11-p-2\" [innerHTML]=\"item.content\"></div>\n    </div>\n  </div>\n</div>\n", styles: [".container-accordion .panel{max-height:0;overflow:hidden;transition:max-height .2s ease-out}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11AccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-accordion', standalone: true, imports: [CommonModule], template: "<div class=\"container-accordion e11-w-full\">\n  <div class=\"accordion-item\" *ngFor=\"let item of data; let i = index\">\n    <div\n      class=\"header e11-block e11-clear-right e11-bg-gray-100 hover:e11-bg-gray-200 e11-p-2 e11-cursor-pointer\"\n      (click)=\"toggleAccordion($event, i)\"\n    >\n      {{ item.sectionName }}\n      <span class=\"material-icons-outlined e11-float-right\" *ngIf=\"!item.isActive\"> expand_more </span>\n      <span class=\"material-icons-outlined e11-float-right\" *ngIf=\"item.isActive\"> expand_less </span>\n    </div>\n    <!-- Panel -->\n    <div #contentPanel class=\"panel\" hide=\"!item.isActive\">\n      <div class=\"e11-p-2\" [innerHTML]=\"item.content\"></div>\n    </div>\n  </div>\n</div>\n", styles: [".container-accordion .panel{max-height:0;overflow:hidden;transition:max-height .2s ease-out}\n"] }]
        }], ctorParameters: () => [], propDecorators: { data: [{
                type: Input
            }], style: [{
                type: Input
            }], opened: [{
                type: Input
            }], activeIndex: [{
                type: Input
            }], multiple: [{
                type: Input
            }], disabledIndex: [{
                type: Input
            }], selectedIndexChange: [{
                type: Output
            }], allPanels: [{
                type: ViewChildren,
                args: ['contentPanel']
            }] } });

class E11AccordionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11AccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11AccordionModule, imports: [E11AccordionComponent], exports: [E11AccordionComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11AccordionModule, imports: [E11AccordionComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11AccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [E11AccordionComponent],
                    exports: [E11AccordionComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11AccordionComponent, E11AccordionModule };
